import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';
import pick from 'lodash/pick';

import { AddressOptions, findAddressById, findAddresses } from '@bodilenergy/address';
import { AddressWithBbrId, DAWAAddress } from '~src/model';
import { formatAddress, toAddressFromDAWAAddress } from '~src/util';

import { Coordinates } from './types';

export const matchDataToAddress = (
  bbrAddresses: DAWAAddress[],
  address: Partial<AddressWithBbrId>
): AddressWithBbrId | undefined =>
  toAddressFromDAWAAddress(
    bbrAddresses.find(
      data =>
        data.id === address.id ||
        data.betegnelse === formatAddress(omit(address, ['id'])) ||
        isEqual(
          omitBy(pick(address, 'city', 'postalCode', 'street', 'houseNumber'), isEmpty),
          omitBy(pick(toAddressFromDAWAAddress(data), 'city', 'postalCode', 'street', 'houseNumber'), isEmpty)
        )
    ),
    true
  );

/** Map position: by DAR address ID when known, otherwise by matching the formatted address. */
export const fetchGeolocationCoordinates = async (
  address: Partial<AddressWithBbrId>,
  options?: AddressOptions
): Promise<Coordinates> => {
  const id = address.id ? String(address.id) : undefined;
  const byId = id ? await findAddressById(id, options) : undefined;

  if (byId) {
    const { latitude, longitude } = toAddressFromDAWAAddress(byId, true) ?? {};

    return { latitude, longitude };
  }

  const withoutId = omit(address, ['id']);
  const candidates = await findAddresses(formatAddress(withoutId), options);
  const { latitude, longitude } = matchDataToAddress(candidates, withoutId) ?? {};

  return { latitude, longitude };
};
